export default __webpack_public_path__ + "static/media/bg-buildings.43ded62d.jpg";